import * as React from 'react';
import { connect } from 'react-redux';
import * as templates from '../../shared/Templates';

import { getUser } from '../../reducers/userReducer';

import * as Features from '../../shared/Features';

export class HomePage extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            showModal: false,
            windowHeight: undefined,
            windowWidth: undefined,
            isMobile: false
        };
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

        if (this.props.user.details.role === 'role/styling-admin') {
            this.props.history.push('/stylingcalendars');
        } else if (Features.hasFeature(Features.ViewStylingCalendar, this.props.user)) {
            //Redirect stylingusers to calendar
            this.props.history.push('/stylingcalendar');
        } else if (Features.hasFeature(Features.ViewUneditedOrdersPage, this.props.user)) {
            //Redirect PhotoEditors to UneditedOrders
            this.props.history.push('/unedited-orders');
        }
    }

    closeModal() {
        this.setState({ showModal: false });
    }

    openModal() {
        this.setState({ showModal: true });
    }

    findStartPageTemplate() {
        if (this.props.content && this.props.content.length > 0) {
            let match = this.props.content.find((c: any) => c.key === templates.StartPage);
            if (match) {
                return match;
            }
        }
        return undefined;
    }

    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }

    handleResize = () =>
        this.setState({
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth,
            isMobile: window.innerWidth <= 991
        });

    render() {
        let template = this.findStartPageTemplate();

        if (template) {
            if (template.isIframe) {
                return (
                    <iframe
                        style={{ overflow: 'hidden' }}
                        width={this.state.windowWidth - 15}
                        height={
                            this.state.isMobile
                                ? this.state.windowHeight * 1.5
                                : this.state.windowHeight
                        }
                        className="homepage-iframe"
                        seamless="seamless"
                        src={template.iFrameUrl}
                    ></iframe>
                );
            } else {
                return (
                    <div className="container page-body">
                        <div
                            id="start-page-template"
                            dangerouslySetInnerHTML={{
                                __html: template.content
                            }}
                        ></div>
                        <div className="push" />
                    </div>
                );
            }
        } else {
            return <div className="container"></div>;
        }
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        content: state.content,
        user: getUser(state)
    };
}

function mapDispatchToProps(dispatch: any) {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
